
  import {Component, Prop, Vue, PropSync} from 'vue-property-decorator';
  import { AddressCardModel } from "@/models";

  @Component
  export default class AddressCard extends Vue {
    @Prop() readonly model!: AddressCardModel;
    @Prop() readonly show!: boolean; //"show", { type: Boolean }
    @PropSync("title", { type: String }) titleSync!: string;

    showAddress: boolean = false;
    toggleAddress() {
      this.showAddress = !this.showAddress;
    }
  }
